//import { PayloadAction } from '@reduxjs/toolkit'

import { getDomain } from '@probatix/common/utils/url'
//import { ActionParams } from '@probatix/common/utils/service'
import LocalStorage from '@probatix/common/utils/localStorage'

import { authServiceActions } from '@probatix/common/services/toolkit/auth'
import { EXPIRATION_TIME_JWT, JWT } from '@probatix/common/services/services.constants'
import { EXPIRY_OF_JWT_TOKEN_MINUTES } from '@probatix/common/config/app'

//type Action = PayloadAction<ActionParams<object> & { token?: string }>

const jwt = { domain: "domain", expiryKey: EXPIRATION_TIME_JWT, key: JWT }

const loginMiddleware =
  (withSubdomain: boolean = true) => () => (next: (action: any) => void) => async (action: any) => {
    if (!authServiceActions.loginSuccess.match(action)) {
      return next(action)
    }

    // NOTE: middleware used for all of the probatix services except login to ensure the single sign on
    const responseData = action!.payload! as any
    if (responseData?.token! && null !== responseData!.token!) {
      const expiry = Date.now() + 1000 * 60 * Number(EXPIRY_OF_JWT_TOKEN_MINUTES)
      LocalStorage.set(jwt.key, responseData.token)
      LocalStorage.set(jwt.expiryKey, expiry)
      LocalStorage.set(jwt.domain, `.${getDomain(withSubdomain)}`)
    }

    return next(action)
  }

export default loginMiddleware
